import { sum } from 'lodash';
import SeatingPreferencesView from '../../views/library/cart-seating-preferences.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IPackageListingAppState } from '../../redux-state/index';
import { updateSeatingPreferences } from '../../redux-state/actions/package-listing.actions';
import flatMap = require('lodash/flatMap');
import uniqBy = require('lodash/uniqBy');


interface StateToProps {
    seatingPreferenceTitle: string;
    seatingPreferencesDefaultText: string;
    seatingPreferenceOptions: string[];
    selectedSeatingPreference: string;
}


interface DispatchToProps {
    updateSeatingPreferences: (notes: string) => void;
}

export type SeatingPreferencesProps = StateToProps & DispatchToProps;


export class SeatingPreferencesBase extends React.Component<SeatingPreferencesProps, any> {
    constructor(props: SeatingPreferencesProps) {
        super(props);
    }

    render() {
        return <SeatingPreferencesView {...this.props} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: SeatingPreferencesProps): StateToProps {
    return {
        seatingPreferenceTitle: state.packageListingText.seatingPreferencesTitle,
        seatingPreferenceOptions: state.packageListingText.seatingPreferenceOptions,
        selectedSeatingPreference: state.packageListing.seatingPreferences,
        seatingPreferencesDefaultText: state.packageListingText.seatingPreferencesDefaultText
    }
}

function mapDispatchToProps(dispatch, ownProps: SeatingPreferencesProps): DispatchToProps {
    return {
        updateSeatingPreferences: (notes) => {
            dispatch(updateSeatingPreferences(notes));
        }

    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(SeatingPreferencesBase);